import React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { palette, Text } from 'main/ui'
import { labelForProgramType } from 'main/util/school'
import { useTranslation } from 'react-i18next'

interface IProps {
  programType: string
}

export default function ProgramType(props: IProps) {
  const { programType } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Text css={{ color: palette.mediumGray, fontSize: '14px' }}>
      {labelForProgramType(programType, t)}
    </Text>
  )
}
